/* eslint-disable */
import httpClient from '@/utils/httpClient'

export class FeaturesVisibilityRepository extends httpClient {
  resource = '/park_management/settings/features_visibility'

  /**
   * getFeaturesVisibility Получить видимость разделов
   * @returns {Promise<[{name: string, isVisible: boolean, featureId: string}]>}
   */
  async getFeaturesVisibility () {
    const response = await this.get(`${this.resource}`)
    return response?.featuresVisibility ?? []
  }

  /**
   * updateFeaturesVisibility Обновить видимость раздела
   * @param {{featureId:string,isVisible:boolean}} featuresVisibilityDto
   * @returns {Promise<void>}
   */
  async updateFeaturesVisibility (featuresVisibilityDto) {
    await this.post(`${this.resource}`, featuresVisibilityDto)
  }
}
